export enum SettingSection {
  Profile = 'profile',
  Location = 'location',
  File = 'file',
  TeamMembers = 'team_members',
  AccessToken = 'access_token',
  WebHook = 'web_hook',
  BrandedTracking = 'branded_tracking',
  AddressBook = 'address_book',
  ProductCatalog = 'product_catalog',
  Logout = 'logout',
}
